import ActivityChallengesListing from './ActivityChallengesListing';

export default ActivityChallengesListing;
